/**
 * Converte uma URL de imagem em dataURL (base64) via canvas.
 * Requer que o servidor da imagem envie CORS habilitado.
 * Emergent Object Storage já vem com CORS liberado.
 */
export async function urlToDataUrl(url) {
  if (!url) return null;
  try {
    return await new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const c = document.createElement("canvas");
          c.width = img.naturalWidth || img.width;
          c.height = img.naturalHeight || img.height;
          c.getContext("2d").drawImage(img, 0, 0);
          resolve(c.toDataURL("image/png"));
        } catch (e) { reject(e); }
      };
      img.onerror = reject;
      img.src = url;
    });
  } catch {
    return null;
  }
}

/**
 * Desenha o cabeçalho padrão do PDF com título, subtítulo e logo/foto do
 * usuário (empresa ou motorista) no canto superior direito.
 */
export async function drawPdfHeader(pdf, { title, subtitle, photoUrl, pageW }) {
  pdf.setFillColor(37, 99, 235);
  pdf.rect(0, 0, pageW, 22, "F");
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(16); pdf.setFont("helvetica", "bold");
  pdf.text(title, 10, 10);
  pdf.setFontSize(10); pdf.setFont("helvetica", "normal");
  pdf.text(subtitle, 10, 17);

  if (photoUrl) {
    const data = await urlToDataUrl(photoUrl);
    if (data) {
      const size = 18; // mm
      const x = pageW - size - 5;
      const y = 2;
      // fundo branco arredondado atrás da logo pra destacar em qualquer imagem
      pdf.setFillColor(255, 255, 255);
      pdf.roundedRect(x - 0.5, y - 0.5, size + 1, size + 1, 2, 2, "F");
      try { pdf.addImage(data, "PNG", x, y, size, size); } catch {}
    }
  }
}
